import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { User } from "@modules/users/types/user";
import { EditUserFormValues } from "@modules/users/validations/editUserSchama";

export async function editUserService(
  id: string,
  data: EditUserFormValues
): Promise<User> {
  if (typeof data.image === "string") {
    delete data.image;
  }

  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: user } = await api.patch<User>(
    `v1/user_admin/${id}/`,
    formatedData,
    { headers }
  );
  return user;
}
